import { Injectable } from '@angular/core';
import { Audience, HostContext, HostLocaleContext, HostPerformanceData, HostUserContext } from '@fluidx/office-fluid-types';

import { CapabilitiesService } from '../../shared/shared-context/capabilities.service';
import { ClientStartupConfigService } from '../../shared/shared-context/client-startup-config.service';
import { ContextService } from '../../shared/shared-context/context.service';
import { mapEnvironmentToAudience } from '../utils/mapEnvironmentToAudience';

export type ScenarioName = 'DirectNav.CreateNew.Abp' | 'DirectNav.CreateNew' | 'DirectNav.Edit' | 'DocumentClick' | 'CreateNew' | 'CreateNew.Abp';

@Injectable({
    providedIn: 'root'
})
export class FluidHostContext implements HostContext {
    constructor(
        private readonly clientStartupConfigService: ClientStartupConfigService,
        private readonly contextService: ContextService,
        private readonly capabilitiesService: CapabilitiesService
        ) {}

    public get HostContext() {
      return this;
    }

    // provide a unique correlation id for host context
    private bootId: number = 0;

    public get audience(): Audience {
        if (this.capabilitiesService.capabilities.fluidAudience !== this.capabilitiesService.getDefaultFluidAudience()) {
            return this.capabilitiesService.capabilities.fluidAudience as Audience;
        }
        const environment = this.clientStartupConfigService.config.sharedClientStartupContext.deploymentEnvironment;
        return mapEnvironmentToAudience(environment);
    }

    public get hostAppVersion(): string {
        return `${this.clientStartupConfigService.config.sharedClientStartupContext.buildId}`;
    }

    public get hostCorrelationId(): string {
        return `${this.clientStartupConfigService.config.sharedClientStartupContext.correlationId}.${this.bootId}`;
    }

    public getBootId(): number {
        return this.bootId;
    }

    public get hostSessionId(): string {
      return this.clientStartupConfigService.config.sharedClientStartupContext.correlationId;
    }

    public hostScenarioName?: string;

    public hostScenarioStartTime?: number;

    public hostPerformanceData?: HostPerformanceData;

    public get hostLocaleContext(): HostLocaleContext {
        return {
            uiLanguage: this.contextService.sharedContext.officeMarket.toLowerCase()
        };
    }

    public get hostName(): string {
      return 'Office.com';
    }

    public get userContext(): HostUserContext {
        return { user: {
            oid: this.clientStartupConfigService.config.puid,
            tenantId: this.clientStartupConfigService.config.tenantId
        }};
    }

    public resetFluidHostContext(shouldResetContext: boolean) {
        if (shouldResetContext) {
            this.hostScenarioStartTime = undefined;
            this.hostScenarioName = undefined;
        }
        // now that the scenario has been reset, increment the boot ID for the next boot.
        this.bootId++;
    }
  }
